import { useChat } from "@/features/chat"
import { useLogger } from "@/features/analytics"
import type { AnalyticsEventName } from "@/features/analytics"

import { AdvisorCarousel } from "./advisor-carousel"
import type { Advisor } from "../types"

interface AdvisorCarouselSectionProps {
  title: string
  subtitle?: string
  advisors: Advisor[]
  /** Analytics event fired (with advisor payload) when the Chat button is tapped. */
  chatEvent: AnalyticsEventName
  /** Card body tap → open the advisor's inner page. */
  onCardClick?: (advisor: Advisor) => void
  /** Chat button tap → start a chat. */
  onChatClick?: (advisor: Advisor) => void
}

/** Section header + advisor carousel, shared by Recommended / MostAccurate / BestInLove / TopRated. */
export function AdvisorCarouselSection({
  title,
  subtitle,
  advisors,
  chatEvent,
  onCardClick,
  onChatClick,
}: AdvisorCarouselSectionProps) {
  const { user } = useChat()
  const { trackAppyCntEvent } = useLogger()

  const handleChat = (advisor: Advisor) => {
    onChatClick?.(advisor)
    trackAppyCntEvent(chatEvent, undefined, {
      user: { uid: user?.uid, name: user?.displayName, host: window.location.host },
      advisor: { name: advisor.name, id: advisor.assistantId, chat_type: chatEvent },
    })
  }

  return (
    <section className="w-full overflow-hidden bg-dark-base pt-6">
      <h2 className="px-4 font-display text-2xl font-medium text-purple-light">{title}</h2>
      {subtitle && <p className="mt-1 px-4 font-body text-base text-purple-light/70">{subtitle}</p>}
      <AdvisorCarousel advisors={advisors} onCardClick={onCardClick} onButtonClick={handleChat} />
    </section>
  )
}
